export default {
  label: 'Interacciones',
  placeholder: 'Indiferente',
  selected: 'seleccionado',
  selectedPlural: 'seleccionados',
};
